import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import Topbar from '../layout/Topbar';
import Navbar from '../layout/Navbar';
import api from '../../api/axios';
import { useBookStore } from '../../provider/BookStore';
import { getErrorMessage, logError } from '../../utils/errorHandler';
import { RotatingLines } from 'react-loader-spinner';

const About = () => {

    const bookState = useBookStore();
    const book = bookState.book;

    const [modalDelete, setModalDelete] = useState(false);
    const [isDisabled, setDisabled] = useState(true);
    const [isLoading, setLoading] = useState(false);
    const [kodeDelete, setKodeDelete] = useState('');
    const [msg,setMsg] = useState('')

    const navigate = useNavigate();

    useEffect(() => {
        console.log(book.id)
        if (book.id === undefined) {
            navigate('/')
        }
    }, []);

    const handleDelete = async() => {
        setLoading(true)
        setDisabled(true)
        try {
            await api.post('/book/delete',{
                book_id:book.id
            })
            deleteSuccess()
        } catch (error) {
            logError('Gagal menghapus buku kas:', error);
            setMsg(getErrorMessage(error, 'Gagal menghapus buku kas. Silakan coba lagi.'));
        } finally {
            setLoading(false)
            setDisabled(false)
        }
    }

    const handleChangeKode = (kode) => {
        setKodeDelete(kode)
        setDisabled(true)
        if (kode === 'DELETE') {
            setDisabled(false)
        }
    }

    const deleteSuccess = ()=>{
        setMsg('Hapus Berhasil, mohon tunggu, menuju ke halaman utama');
        setTimeout(()=>{
            navigate('/');
        },3000);
    }

    const getPeriode = ()=>{
        const name = ['daily','weekly','monthly','yearly','custom'];
        const nama = ['Harian','Mingguan','Bulanan','Tahunan','Custom'];
        return(nama[name.indexOf(book.display)])
      }

    const renderModalDelete = () => {
        if (book.group === 'member') {
            return (
                <div className={`modal p-5 ${modalDelete ? 'is-active' : ''}`}>
                    <div className="modal-background"></div>
                    <div className="modal-content card">
                        <header className='card-header'>
                            <p className="card-header-title">Hapus Buku Kas {book.title}</p>
                            <button className="card-header-icon" onClick={() => setModalDelete(!modalDelete)}>
                                <i className="fa fa-times" aria-hidden="true"></i>
                            </button>
                        </header>
                        <div className='card-content'>
                            <p>
                                Anda tidak memiliki wewenang untuk tindakan ini. Silahkan hubungi owner dari Buku Kas {book.title}
                            </p>
                        </div>
                    </div>

                </div>
            )
        } else {

            return (
                <div className={`modal p-5 ${modalDelete ? 'is-active' : ''}`}>
                    <div className="modal-background"></div>
                    <div className="modal-content card">
                        <header className='card-header'>
                            <p className="card-header-title">Hapus Buku Kas {book.title}</p>
                            <button className="card-header-icon" onClick={() => setModalDelete(!modalDelete)}>
                                <i className="fa fa-times" aria-hidden="true"></i>
                            </button>
                        </header>
                        <div className='card-content'>
                            <p>
                                Proses ini akan menghapus seluruh data yang berkaitan dengan buku kas 
                                <b> {book.title} </b>seperti data transaksi, kategori, dan hutang secara permanen.
                            </p>
                            <p className='mt-5'>
                                ketik "DELETE" pada kotak berikut untuk melanjutkan.
                            </p>
                            <div className="field mt-2">
                                {/* <label className="label">Email</label> */}
                                <div className="controls">
                                    <input type="text" className="input" placeholder=''
                                        value={kodeDelete} onChange={(e) => handleChangeKode(e.target.value)} />
                                </div>
                            </div>
                            <div className='has-text-centered'>
                                <RotatingLines
                                    visible={isLoading}
                                    height="20"
                                    width="20"
                                    strokeColor="gray"
                                    strokeWidth="5"
                                    animationDuration="0.75"
                                    ariaLabel="rotating-lines-loading"
                                />
                                <span>{msg}</span>
                            </div>
                        </div>
                        <footer className='card-footer'>
                            <button className='card-footer-item' onClick={() => setModalDelete(!modalDelete)}>Batal</button>
                            <button className='card-footer-item has-text-danger'
                                onClick={() => handleDelete()} disabled={isDisabled}>
                                DELETE
                            </button>
                        </footer>
                    </div>

                </div>
            )
        }
    }

    return (
        <div>
            <Topbar
                //book={book}
                page={'transaksi'}
                title={book.title}
                back={() => navigate('/')}
            />
            <div className='container p-5'>

                <div className="columns is-centered">
                    <div className="column is-5-widescreen is-6-desktop is-7-tablet">
                        <div className='is-clearfix is-clickable' onClick={()=>navigate('/book/add',{state:{action:'edit'}})}>
                            <div className='is-pulled-left'>

                                <p className='is-size-6'>Nama Buku</p>
                                <p className='is-size-7'>{book.title}</p>
                            </div>
                            <div className='is-pulled-right'>
                                <span className="icon ">
                                    <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>
                        <hr className='mb-3 mt-3' />

                        <div className='is-clearfix is-clickable' onClick={() => navigate('/categories')}>
                            <div className='is-pulled-left'>

                                <p className='is-size-6'>Kategori</p>
                                <p className='is-size-7'>daftar kategori</p>
                            </div>
                            <div className='is-pulled-right'>
                                <span className="icon ">
                                    <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>
                        <hr className='mb-3 mt-3' />

                        <div className='is-clearfix is-clickable' onClick={() => navigate('/book/import')}>
                            <div className='is-pulled-left'>

                                <p className='is-size-6'>Import CSV</p>
                                <p className='is-size-7'>import transaksi massal dari file CSV</p>
                            </div>
                            <div className='is-pulled-right'>
                                <span className="icon ">
                                    <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>
                        <hr className='mb-3 mt-3' />

                        <div className='is-clearfix is-clickable' onClick={() => navigate('/pocket')}>
                            <div className='is-pulled-left'>

                                <p className='is-size-6'>Dompet</p>
                                <p className='is-size-7'>daftar dompet (budget)</p>
                            </div>
                            <div className='is-pulled-right'>
                                <span className="icon ">
                                    <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>
                        <hr className='mb-3 mt-3' />

                        <div className='is-clearfix is-clickable' onClick={() => navigate('/members')}>
                            <div className='is-pulled-left'>

                                <p className='is-size-6'>Member</p>
                                <p className='is-size-7'>anggota yang punya akses</p>
                            </div>
                            <div className='is-pulled-right'>
                                <span className="icon ">
                                    <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>
                        <hr className='mb-3 mt-3' />

                        <div className='is-clearfix is-clickable' onClick={() => navigate('/debt')}>
                            <div className='is-pulled-left'>

                                <p className='is-size-6'>Hutang</p>
                                <p className='is-size-7'>Daftar Hutang</p>
                            </div>
                            <div className='is-pulled-right'>
                                <span className="icon ">
                                    <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>
                        <hr className='mb-3 mt-3' />

                        <div className='is-clearfix is-clickable' onClick={() => navigate('/periode')}>
                            <div className='is-pulled-left'>

                                <p className='is-size-6'>Tampilan</p>
                                <p className='is-size-7'>{getPeriode()}</p>
                            </div>
                            <div className='is-pulled-right'>
                                <span className="icon ">
                                    <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>
                        <hr className='mb-3 mt-3' />

                        <button className='button mt-6 is-fullwidth has-text-danger'
                            onClick={() => setModalDelete(!modalDelete)}>
                            Hapus Buku Kas {book.title}
                        </button>

                        {renderModalDelete()}

                    </div>

                </div>
            </div>
            <Navbar
                book={book}
            />
        </div>
    )
}

export default About
